import { useToast as useChakraToast } from '@chakra-ui/react';

/**
 * App-wide toast defaults.
 */
const DEFAULT_OPTIONS = {
  position: 'top',
  isClosable: true,
};

/**
 * @param {import('@chakra-ui/react').UseToastOptions} [options] Merged on top of app defaults (can override `position`, etc.).
 */
export function useToast(options) {
  return useChakraToast({ ...DEFAULT_OPTIONS, ...options });
}
